import { DateTime } from "luxon";
import { Box } from "../../components/Box";
import { Card } from "../../components/Card";
import { Paragraph } from "../../components/Paragraph";
import { renderCheckDetail } from "./renderCheckDetail";

type CheckDetailPanelEntry = {
  id: number;
  name: string;
  status: { status: string };
  updated_at: string;
};

type Props = {
  check?: CheckDetailPanelEntry | null;
  type?: "individual" | "entity";
};

/** Full width beneath the tab strip, on one card, replacing the 60% column. */
export const CheckDetailPanel = ({ check, type }: Props) => {
  if (!check) {
    return null;
  }

  const isPending = check.status?.status === "pending";

  return (
    <Card p={"0px !important"}>
      {!isPending && (
        <Box px={3} pt={3}>
          <Paragraph fontSize={1} color="gray.50" mt={0} mb={0}>
            Last updated{" "}
            {check.updated_at
              ? DateTime.fromISO(check.updated_at).toFormat("dd/MM/yyyy")
              : "-"}
          </Paragraph>
        </Box>
      )}

      {isPending ? (
        <Box p={3}>
          <Paragraph mt={0} mb={0} color="gray.60">
            This check has not run yet.
          </Paragraph>
        </Box>
      ) : (
        renderCheckDetail({ name: check.name, id: check.id, type })
      )}
    </Card>
  );
};
